import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { capitalizeFirstLetter, checkUndefine, vietnameseStringToUnicode, columnsTable } from '../../../../../../helpers/functions';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
} from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import { Option } from '../../../../common/component/Select';
import Maps from "../../../../common/component/Maps";
import { Select, Switch, Table } from "antd";
import Input from "../../../../common/component/Input";
import { find, get } from 'lodash';

import './styles.less';
import { DETAIL_ACTIONS, INSTALLMENT as INSTALLMENT_ENUM } from '../../../../../../constants/Define';

class AddressInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    render() {
        const { t, hotel, provinces, locations, validation, action, tagGroups } = this.props;
        const { } = this.state;
        const isInstallment = hotel.installmentFee || hotel.installmentLimit
        return (
            <Wrapper className="address-info-section">
                <h3 className={`ml-3`}>{t('item.hotel.addressInfo')}</h3>
                <FormWrapperItem>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.province`)}
                        >
                            <Select className="select-province"
                                showSearch filterOption={this.selectFilterSearch}
                                showArrow
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.hotel.province")).toLowerCase())}
                                value={hotel.province && hotel.province.id}
                                onChange={this.onChangeProvince}
                                style={{ width: '100%' }}
                            >
                                {provinces.map(p => (
                                    <Select.Option key={p.id} value={p.id}>{p.name}</Select.Option>
                                ))}
                            </Select>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={hotel.locationId}
                            validation={validation.locationId}
                            labelTitle={t(`item.hotel.location`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Select className="select-location"
                                showSearch filterOption={this.selectFilterSearch}
                                showArrow
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.hotel.location")).toLowerCase())}
                                value={hotel.locationId}
                                onChange={this.onChangeLocation}
                                style={{ width: '100%' }}
                            >
                                {locations.map(l => (
                                    <Select.Option key={l.id} value={l.id}>{l.name}</Select.Option>
                                ))}
                            </Select>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.address`)}
                        >
                            <Maps.AddressInput value={checkUndefine(hotel.address)} onChange={this.onChangeAddress} onSelect={this.props.onSelectPlace} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.addressHyperLink`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`addressHyperLink`} onChange={(e) => this.props.onChange('addressHyperLink', e.target.value.trimLeft())}
                                value={hotel.addressHyperLink} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12 location-on-map">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.hotel.locationOnMap`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Maps.GoogleMap
                                center={get(hotel, 'position')}
                                markers={get(hotel, 'position') ? [get(hotel, 'position')] : []}
                                onMarkerDrag={this.onPositionChange} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                </FormWrapperItem>
                <FormWrapperItem>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            typeInput={true}
                            messageBelowInput={true}
                            isRequired={isInstallment ? 'right' : false}
                            isValidation={true}
                            dataValidation={hotel.installmentFee}
                            validation={validation.installmentFee}
                            labelTitle={t(`item.group.installmentFee`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Wrapper style={{ display: 'flex' }}>
                                <AntSelect
                                    placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.hotel.installmentFee")).toLowerCase())}
                                    value={checkUndefine(hotel.installmentFee)}
                                    onChange={(e) => this.props.onChange('installmentFee', e)}
                                    style={{ width: '100%' }}
                                >
                                    <Select.Option key={0} value=''>{t(`item.hotel.installmentFee_enum.UN_KNOW`)}</Select.Option>
                                    {INSTALLMENT_ENUM.INSTALLMENT_FREE.map((value, index) => {
                                        return <AntOption key={index + 1} value={value}>{t(`item.hotel.installmentFee_enum.${value}`)}</AntOption>
                                    })}
                                </AntSelect>
                            </Wrapper>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            typeInput={true}
                            messageBelowInput={true}
                            isRequired={isInstallment ? 'right' : false}
                            isValidation={true}
                            dataValidation={hotel.installmentLimit}
                            validation={validation.installmentLimit}
                            labelTitle={t(`item.hotel.installmentLimit`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Wrapper style={{ display: 'flex' }}>
                                <AntSelect
                                    placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.hotel.installmentLimit")).toLowerCase())}
                                    value={checkUndefine(hotel.installmentLimit)}
                                    onChange={(e) => this.props.onChange('installmentLimit', e)}
                                    style={{ width: '100%' }}
                                >
                                    <Select.Option key={0} value=''>{t(`item.hotel.installmentLimit_enum.UN_KNOW`)}</Select.Option>
                                    {Object.keys(INSTALLMENT_ENUM.INSTALLMENT_LIMIT).map((value, index) => {
                                        return <AntOption key={index + 1} value={INSTALLMENT_ENUM.INSTALLMENT_LIMIT[value]}>{t(`item.hotel.installmentLimit_enum.${value}`)}</AntOption>
                                    })}
                                </AntSelect>
                            </Wrapper>
                        </FormWrapperInputComponent>
                    </Wrapper>
                </FormWrapperItem>
                <FormWrapperItem>
                    <Wrapper className="col-md-12">
                        {/* {this.renderTagsHotel()} */}
                    </Wrapper>
                </FormWrapperItem>
            </Wrapper>
        );
    }

    onChangeAddress = (e) => {
        return this.props.onChange && this.props.onChange('address', (e.target.value || '').trimLeft());
    }

    onChangeLocation = (locationId) => {
        return this.props.onChange('locationId', locationId);
    }

    onChangeProvince = (provinceId) => {
        const province = find(this.props.provinces || [], p => p.id === provinceId);
        return this.props.onChange('province', province);
    }

    onPositionChange = (marker, event, index) => {
        if (event.position) {
            const position = {
                lat: event.position.lat(),
                lng: event.position.lng(),
            }
            this.props.onChange && this.props.onChange('position', position);
        }
    }

    selectFilterSearch = (input, option) => {
        const optionText = vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    renderTagsHotel = ()=> {
        const { t, tagGroups } = this.props;
        const columns = {
            name: {
                key: 'name',
                width: 200
            },
            isActiveListing: {
                key: 'isActiveListing',
                width: 150,
                align: 'center',
                render: (value, record, idx)=>
                    <Switch
                        checked={value}
                        onChange={value => this.props.onChangeTags('isActiveListing', value, idx)}
                    />
                    
                
            }
        };
   
        return (
            <Table 
                columns={columnsTable({
                    titleTable: ['name', 'isActiveListing'],
                    component: columns,
                    itemName: 'hotel.hotelTags'
                })}
                dataSource={tagGroups || []} 
                size="small" 
                className="table-tag-hotel"
            />
        )
    }

}

export default withTranslation()(AddressInfo);
